import MarketPriceDetail from "./marketPriceDetail";
export default MarketPriceDetail;